import React from 'react';
import { Alert, IconButton } from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';

const AnnouncementBar = ({ announcement, onDismiss }) => {
    if (!announcement) return null;

    return (
        <Alert
            severity={announcement.type || 'info'}
            variant="filled"
            sx={{ borderRadius: 0, alignItems: 'center' }}
            action={
                <IconButton size="small" color="inherit" onClick={onDismiss} aria-label="Dismiss announcement">
                    <CloseIcon fontSize="small" />
                </IconButton>
            }
        >
            <strong>{announcement.title}</strong>{announcement.title ? ' — ' : ''}{announcement.message}
        </Alert>
    );
};

export default AnnouncementBar;
